import React from 'react';
import './title.css';

interface TitleProps {
    text: string;
}

export const Title: React.FC<TitleProps> = ({ text }) => {
    return (
        <>
            <h2 className="app-title">{text}</h2>
        </>
    );
};
